<template>
    <div v-if="documento" class="modal-overlay">
        <div class="modal-content proc-modal-analise">
            <h3>Análise do documento</h3>
            <div class="row-space"></div>
            <p class="proc-modal-subtitle">{{ documento.nmreferencia }}</p>

            <div class="row row-space">
                <div class="form-item-char20">
                    <label class="label-caption">Resultado</label>
                    <select v-model="cdResultadoLocal">
                        <option value="A">Aprovado</option>
                        <option value="R">Reprovado</option>
                    </select>
                </div>
            </div>

            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Justificativa</label>
                    <textarea v-model="justificativaLocal" maxlength="5000" rows="5" />
                </div>
            </div>

            <div class="row-end row-space">
                <button class="btn-small proc-btn primary" type="button" @click="confirmar">Salvar</button>
                <button class="btn-small proc-btn" type="button" @click="$emit('fechar')">Fechar</button>
            </div>

            <div v-if="msgAlerta" class="info-alert row-space clickabe-row" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    documento: { type: Object, default: null },
});

const emit = defineEmits(['salvar', 'fechar']);
const msgAlerta = ref(null);

const cdResultadoLocal = ref('A');
const justificativaLocal = ref('');

watch(
    () => props.documento,
    (doc) => {
        cdResultadoLocal.value = doc?.cdanalise || 'A';
        justificativaLocal.value = doc?.analise_justificativa || '';
    },
    { immediate: true },
);

function confirmar() {
    msgAlerta.value= null;
    if (cdResultadoLocal.value === 'R' && !justificativaLocal.value){
        msgAlerta.value = 'Necessário informar justificativa';
        return;
    }
    emit('salvar', {
        documento: props.documento,
        cdresultado: cdResultadoLocal.value,
        justificativa: justificativaLocal.value,
    });
}
</script>
